import { Show } from "solid-js";
import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  value?: number;
  max?: number;
  indeterminate?: boolean;
  tone?: "accent" | "success" | "warning" | "error";
  label?: string;
  showPercent?: boolean;
  height?: number;
}

export function ProgressBar(props: ProgressBarProps) {
  const tone = props.tone ?? "accent";
  const max = props.max ?? 100;
  const ratio = () => {
    if (props.indeterminate) return 0;
    if (max <= 0) return 0;
    const v = props.value ?? 0;
    return Math.max(0, Math.min(1, v / max));
  };
  const pct = () => Math.round(ratio() * 100);

  return (
    <div class={styles.wrap}>
      <Show when={props.label || props.showPercent}>
        <div class={styles.head}>
          <Show when={props.label}><span class={styles.label}>{props.label}</span></Show>
          <Show when={props.showPercent && !props.indeterminate}><span class={styles.pct}>{pct()}%</span></Show>
        </div>
      </Show>
      <div
        class={styles.track}
        style={{ height: `${props.height ?? 6}px` }}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={props.indeterminate ? undefined : (props.value ?? 0)}
      >
        <Show
          when={!props.indeterminate}
          fallback={<div class={`${styles.fill} ${styles[tone]} ${styles.indeterminate}`} />}
        >
          <div class={`${styles.fill} ${styles[tone]}`} style={{ width: `${pct()}%` }} />
        </Show>
      </div>
    </div>
  );
}
